// src/services/api.service.ts
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { authService } from './auth.service';

class ApiService {
    private api: AxiosInstance;

    constructor() {
        this.api = axios.create({
            baseURL: (process.env.REACT_APP_API_URL || 'http://localhost:3000').replace(/\/+$/, ''),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Interceptor để thêm token
        this.api.interceptors.request.use((config) => {
            const token = authService.getAccessToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });

        // Interceptor để refresh token
        this.api.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config;
                if (error.response?.status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true;
                    try {
                        const newToken = await authService.refreshToken();
                        if (newToken) {
                            originalRequest.headers.Authorization = `Bearer ${newToken}`;
                            return this.api(originalRequest);
                        }
                    } catch (refreshError) {
                        authService.logout();
                        window.location.href = '/login';
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.api.get<T>(url, config).then(res => res.data);
    }

    post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        return this.api.post<T>(url, data, config).then(res => res.data);
    }

    put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        return this.api.put<T>(url, data, config).then(res => res.data);
    }

    patch<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        return this.api.patch<T>(url, data, config).then(res => res.data);
    }

    delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.api.delete<T>(url, config).then(res => res.data);
    }
}

export const apiService = new ApiService();